/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReceiptFieldResponse } from './ReceiptFieldResponse';
import {
    ReceiptFieldResponseFromJSON,
    ReceiptFieldResponseFromJSONTyped,
    ReceiptFieldResponseToJSON,
} from './ReceiptFieldResponse';

/**
 * 
 * @export
 * @interface SoftpayReceiptDto
 */
export interface SoftpayReceiptDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof SoftpayReceiptDto
     */
    receipt: Array<string>;
    /**
     * 
     * @type {{ [key: string]: ReceiptFieldResponse; }}
     * @memberof SoftpayReceiptDto
     */
    fields: { [key: string]: ReceiptFieldResponse; };
}

/**
 * Check if a given object implements the SoftpayReceiptDto interface.
 */
export function instanceOfSoftpayReceiptDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "receipt" in value;
    isInstance = isInstance && "fields" in value;

    return isInstance;
}

export function SoftpayReceiptDtoFromJSON(json: any): SoftpayReceiptDto {
    return SoftpayReceiptDtoFromJSONTyped(json, false);
}

export function SoftpayReceiptDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SoftpayReceiptDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'receipt': json['receipt'],
        'fields': (mapValues(json['fields'], ReceiptFieldResponseFromJSON)),
    };
}

export function SoftpayReceiptDtoToJSON(value?: SoftpayReceiptDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'receipt': value.receipt,
        'fields': (mapValues(value.fields, ReceiptFieldResponseToJSON)),
    };
}

